import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import logoImage from '../../img/logo.png';
import './LegalPages.css';

const PrivacyPolicyPage = () => {
  useEffect(() => {
    document.title = 'Política de Privacidade | Fluxo Clínica';
  }, []);

  return (
    <div className="legal-page">
      <div className="legal-page__container">
        <header className="legal-page__header">
          <Link to="/inicio" aria-label="Ir para a página inicial do Fluxo Clínica">
            <img src={logoImage} alt="Fluxo Clínica" className="legal-page__logo" />
          </Link>
          <Link to="/inicio" className="legal-page__back">Voltar ao site</Link>
        </header>

        <main className="legal-page__content">
          <h1>Política de Privacidade</h1>
          <p className="legal-page__updated">Última atualização: 26 de agosto de 2026.</p>

          <p>
            Esta Política explica como o <strong>Fluxo Clínica</strong> trata dados pessoais
            em sua plataforma de gestão para clínicas, em seus sites e nas integrações com
            canais de comunicação, incluindo Meta e Instagram.
          </p>

          <h2>1. Quem somos e como entrar em contato</h2>
          <p>
            O responsável pela plataforma é o <strong>Fluxo Clínica</strong>. Solicitações
            relacionadas a privacidade e proteção de dados podem ser enviadas para{' '}
            <a href="mailto:reinaldofp@gmail.com">reinaldofp@gmail.com</a>.
          </p>

          <h2>2. Papéis no tratamento de dados</h2>
          <p>
            Cada clínica cliente geralmente atua como controladora dos dados de seus
            pacientes, profissionais e contatos, decidindo as finalidades do tratamento.
            Nesses casos, o Fluxo Clínica atua como operador, tratando os dados conforme as
            instruções da clínica. O Fluxo Clínica pode atuar como controlador dos dados
            necessários para cadastro, contratação, cobrança, segurança, suporte e
            relacionamento com seus próprios usuários e potenciais clientes.
          </p>

          <h2>3. Dados que podemos tratar</h2>
          <ul>
            <li>Dados cadastrais e de contato, como nome, e-mail, telefone, CPF e função profissional.</li>
            <li>Dados da clínica, seus colaboradores, serviços, agendas, atendimentos e operações.</li>
            <li>Dados de pacientes e dados pessoais sensíveis de saúde inseridos pela clínica.</li>
            <li>Dados comerciais, contratuais e de cobrança, com pagamentos processados por fornecedores especializados.</li>
            <li>Registros técnicos, como endereço IP, dispositivo, navegador, data, horário e logs de segurança.</li>
            <li>Comunicações enviadas ao suporte ou realizadas pelos canais integrados.</li>
          </ul>

          <h2>4. Dados da Meta e do Instagram</h2>
          <p>
            Quando uma clínica conecta uma conta profissional do Instagram, podemos receber
            e tratar identificadores da conta e do usuário no Instagram, nome de usuário,
            nome e foto de perfil quando disponibilizados, mensagens, anexos, comentários,
            respostas a Stories, referências a publicações e dados técnicos dos eventos.
          </p>
          <p>
            O Instagram normalmente não fornece ao Fluxo Clínica o e-mail, telefone,
            aniversário ou endereço da pessoa que envia uma mensagem ou comentário. Esses
            dados somente serão registrados quando forem fornecidos pelo próprio titular ou
            legitimamente inseridos pela clínica.
          </p>

          <h2>5. Finalidades do tratamento</h2>
          <ul>
            <li>Disponibilizar agenda, prontuário, relacionamento, pipeline e demais funcionalidades contratadas.</li>
            <li>Transformar interações autorizadas em atendimentos ou oportunidades vinculadas à clínica correta.</li>
            <li>Permitir que a clínica responda mensagens e comentários pelos canais integrados.</li>
            <li>Autenticar usuários, prevenir fraudes, proteger contas e manter registros de auditoria.</li>
            <li>Prestar suporte, processar cobranças e cumprir obrigações contratuais e legais.</li>
            <li>Melhorar a estabilidade, segurança e experiência da plataforma.</li>
          </ul>

          <h2>6. Bases legais</h2>
          <p>
            O tratamento poderá se apoiar, conforme o contexto, na execução de contrato,
            cumprimento de obrigação legal ou regulatória, exercício regular de direitos,
            proteção da vida, tutela da saúde, legítimo interesse e consentimento. A clínica
            é responsável por definir e documentar as bases legais aplicáveis aos dados que
            controla, especialmente dados de pacientes e dados de saúde.
          </p>

          <h2>7. Compartilhamento e fornecedores</h2>
          <p>
            Dados podem ser compartilhados, no limite necessário, com fornecedores de
            hospedagem, infraestrutura, segurança, comunicação, suporte, pagamentos e com a
            Meta para operar as integrações com Instagram. Também poderemos compartilhar
            informações quando exigido por lei, ordem judicial ou autoridade competente.
            Não comercializamos dados pessoais.
          </p>

          <h2>8. Transferências internacionais</h2>
          <p>
            Alguns fornecedores, incluindo a Meta e prestadores de infraestrutura, podem
            processar dados fora do Brasil. Nesses casos, buscamos utilizar fornecedores e
            mecanismos compatíveis com a legislação aplicável de proteção de dados.
          </p>

          <h2>9. Retenção e exclusão</h2>
          <p>
            Mantemos dados pelo período necessário às finalidades informadas, ao contrato e
            às obrigações legais, regulatórias e de defesa de direitos. Dados clínicos e de
            prontuário podem estar sujeitos a prazos obrigatórios de guarda definidos pela
            legislação e por normas profissionais. Ao final do período aplicável, os dados
            poderão ser eliminados ou anonimizados.
          </p>

          <h2>10. Segurança</h2>
          <p>
            Adotamos medidas administrativas e técnicas destinadas a reduzir riscos de
            acesso não autorizado, perda, alteração ou divulgação indevida, incluindo
            controles de acesso, registros de auditoria e proteção de credenciais. Nenhum
            ambiente é totalmente imune a incidentes, mas avaliamos e aprimoramos
            continuamente nossas medidas de proteção.
          </p>

          <h2>11. Direitos dos titulares</h2>
          <p>
            Nos termos da LGPD, o titular pode solicitar, quando aplicável, confirmação do
            tratamento, acesso, correção, informação sobre compartilhamento, anonimização,
            bloqueio, portabilidade, eliminação, oposição e revogação do consentimento. Se os
            dados forem controlados por uma clínica, encaminharemos ou auxiliaremos o
            atendimento junto à clínica responsável.
          </p>
          <p>
            Para exercer esses direitos, escreva para{' '}
            <a href="mailto:reinaldofp@gmail.com">reinaldofp@gmail.com</a>. Poderemos solicitar
            informações para confirmar a identidade e proteger o titular contra solicitações fraudulentas.
          </p>

          <h2>12. Cookies e tecnologias semelhantes</h2>
          <p>
            Podemos utilizar armazenamento local, cookies essenciais e tecnologias
            semelhantes para autenticação, segurança, preferências e funcionamento da
            plataforma. Cookies não essenciais, quando utilizados, serão tratados conforme
            as escolhas e regras aplicáveis.
          </p>

          <h2>13. Alterações desta Política</h2>
          <p>
            Esta Política poderá ser atualizada para refletir mudanças legais, operacionais
            ou tecnológicas. A versão vigente e sua data de atualização permanecerão
            disponíveis nesta página.
          </p>

          <div className="legal-page__notice">
            Para solicitar a remoção de dados relacionados à Meta ou ao Instagram, consulte
            também as <Link to="/exclusao-de-dados">Instruções para Exclusão de Dados</Link>.
          </div>
        </main>

        <footer className="legal-page__footer">© 2026 Fluxo Clínica.</footer>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;
